export const LOADER_CATEGORIA_DESEMPENIO          =       'LOADER_CATEGORIA_DESEMPENIO  ';
export const GET_CATEGORIA_DESEMPENIO             =       'GET_CATEGORIA_DESEMPENIO  ';
export const CATEGORIA_DESEMPENIO_FALLA           =       'CATEGORIA_DESEMPENIO_FALLA  ';
export const SAVE_LOADER_CATEGORIA_DESEMPENIO     =       'SAVE_LOADER_CATEGORIA_DESEMPENIO';
export const FORM_CATEGORIA_DESEMPENIO_FAIL       =       'FORM_CATEGORIA_DESEMPENIO_FAIL';

